// Dependencies
import { MAX_MOBILE_WIDTH } from "config/theme";
import { useState, useEffect, useCallback } from "react";

interface IgetWindowDimensions {
  width: number | null;
  height: number | null;
}
const hasWindow = typeof window !== "undefined";

export const useCheckMobile = (): boolean => {
  const getWindowDimensions = useCallback(() => {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return { width, height };
  }, []);

  const [windowDimensions, setWindowDimensions] =
    useState<IgetWindowDimensions>(getWindowDimensions());

  useEffect(() => {
    if (hasWindow) {
      const handleResize = () => {
        setWindowDimensions(getWindowDimensions());
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [getWindowDimensions]);

  if (windowDimensions.width) {
    return windowDimensions.width <= MAX_MOBILE_WIDTH;
  } else {
    return false;
  }
};
